import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a9c8dba&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2a9c8dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c8dba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a9c8dba')) {
      api.createRecord('2a9c8dba', component.options)
    } else {
      api.reload('2a9c8dba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a9c8dba&scoped=true&", function () {
      api.rerender('2a9c8dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/index.vue"
export default component.exports